import api from "../utils/axiosInstance";

const API = "user";

export const update2fa = async (data) => {
  try {
    const response = await api.post(`/${API}/update2fa`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getVerifyDetails = async (data) => {
  try {
    const response = await api.post(`/${API}/check-verify`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateKYC = async (data) => {
  try {
    const response = await api.post(`/${API}/submit-kyc`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    return error;
  }
};